import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { NEWS } from '../mock';
import { Calendar, Tag, Search, Instagram, MapPin } from 'lucide-react';

export default function News() {
  const [q, setQ] = useState('');
  const filtered = NEWS.filter((n) => `${n.title} ${n.excerpt} ${n.tag}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="fade-in-up">
      <section className="banner-bg section-noise">
        <div className="max-w-6xl mx-auto px-4 py-14">
          <div className="chip mb-3">REGION III</div>
          <h1 className="font-display text-5xl md:text-6xl text-cbtu-cream">NEWS &amp; <span className="gold-text-fill">STATEMENTS</span></h1>
          <div className="mt-6 max-w-md relative">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gold" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search news..." className="w-full bg-cbtu-black border border-gold/30 focus:border-gold rounded-sm pl-9 pr-3 py-2.5 text-sm text-cbtu-cream outline-none" />
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((n) => (
          <article key={n.id} className="card-dark rounded-md overflow-hidden">
            <div className="aspect-[16/10] overflow-hidden bg-cbtu-black relative">
              {n.img ? (
                <img src={n.img} alt={n.title} className={`w-full h-full object-cover ${n.imgTop ? 'object-top' : ''}`} loading="lazy" />
              ) : (
                <div className={`w-full h-full flex items-center justify-center ${n.accent === 'green' ? 'bg-gradient-to-br from-[#1f4a28] to-[#0f1530]' : n.accent === 'navy' ? 'bg-gradient-to-br from-[#0f1530] to-[#0a0e1a]' : 'bg-gradient-to-br from-[#2a1f08] to-[#0a0e1a]'}`}>
                  <div className="text-center px-6">
                    <div className="text-4xl mb-2 text-gold">★</div>
                    <div className="font-display gold-text-fill text-xl tracking-wide">CBTU REGION III</div>
                    <div className="font-heading text-xs tracking-widest text-cbtu-cream/70 mt-1">{n.tag.toUpperCase()}</div>
                  </div>
                </div>
              )}
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2 text-xs">
                <span className="chip inline-flex items-center gap-1"><Tag size={10} />{n.tag}</span>
                <span className="text-cbtu-muted inline-flex items-center gap-1"><Calendar size={12} className="text-gold" />{n.date}</span>
              </div>
              <h2 className="font-heading text-lg text-cbtu-cream leading-snug mb-2">{n.title}</h2>
              <p className="text-sm text-cbtu-text/85">{n.excerpt}</p>
              <div className="mt-4 flex items-center justify-between gap-3 flex-wrap">
                {n.link ? (
                  <Link to={n.link} className="text-gold hover:text-gold-bright text-xs font-heading tracking-widest" data-testid={`news-readmore-${n.id}`}>{n.linkLabel || 'VIEW PARKING FLYER →'}</Link>
                ) : (
                  <button onClick={() => alert('Full article coming soon.')} className="text-gold hover:text-gold-bright text-xs font-heading tracking-widest">READ MORE →</button>
                )}
                <div className="flex items-center gap-2">
                  {n.chapterSlug && (
                    <Link to={`/chapters/${n.chapterSlug}`} className="inline-flex items-center gap-1 text-cbtu-muted hover:text-gold-bright text-[11px] font-heading tracking-widest" aria-label={`View ${n.tag} chapter`}>
                      <MapPin size={11} /> CHAPTER
                    </Link>
                  )}
                  {n.instagram && (
                    <a href={n.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-cbtu-muted hover:text-gold-bright text-[11px] font-heading tracking-widest" aria-label={`Follow ${n.socialHandle || 'this chapter'} on Instagram`}>
                      <Instagram size={11} /> {n.socialHandle || 'INSTAGRAM'}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </article>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-full text-center text-cbtu-muted py-10">No articles match your search.</div>
        )}
      </section>
    </div>
  );
}
